module.exports = __webpack_public_path__ + "static/media/excel.ddeb051a.svg";